import { chain, pick } from "lodash"
import { assetClassKeyMapIteratee } from "helpers/securities"
import { sanitizeBasketTicker } from "helpers/swaps"

const NAME_PATTERN = /^[A-Za-z0-9_\-\s]{3,50}$/

export const validateExperimentName = (name) => {
  return name.match(NAME_PATTERN)
}

export const validateExperimentDescription = (description) => {
  if (!description) {
    return true
  }
  return description.length <= 280
}
export function computeId(position) {
  const { id, ticker, mic, internalId, modelProviderId, assetClass, bloombergTicker, figi } = position
  switch (assetClass) {
    case "equity":
      return {
        // only send ticker, mic if you have both
        ...(ticker && mic && { ticker, mic }),
        bloombergTicker,
        figi,
        internalId,
        modelProviderId,
      }
    case "fixedIncome":
      return {
        isin: id,
      }
    case "swap":
      return sanitizeBasketTicker(ticker || id)
    default:
      return ticker || id
  }
}

/** Convert composition positions to position set date asset groups */
export function computeExperiment(positions) {
  return chain(positions)
    .groupBy("assetClass")
    .mapKeys(assetClassKeyMapIteratee)
    .mapValues((assetClasses) =>
      chain(assetClasses)
        .map(position => ({
          id: computeId(position),
          ...pick(position, ["economicExposure", "attributes"]),
        }))
        .compact()
        .value(),
    )
    .value()
}
